export default __webpack_public_path__ + "static/media/health-info.8cd79810.jpg";